import { Curriculum, CurriculumResult } from "../../../../api/types";
import { AreaAggMap, StrandAggMap, NameAggMap } from "../../../../api/types";

// FYI: to avoid loooooong variable name, "Agg" means "Aggregated"
export function handleCurriculum(data: CurriculumResult[]): AreaAggMap {
	let aggMap: AreaAggMap = new Map<
		string,
		Map<string, Map<string, Curriculum[]>>
	>();
	if (data) {
		data.forEach((currRes) => {
			const curr: Curriculum = currRes.curriculumDetails;
			// <LearningArea, Strand>
			if (!aggMap.has(curr.learningArea)) {
				aggMap.set(
					curr.learningArea,
					new Map<string, Map<string, Array<Curriculum>>>(),
				);
				aggMap = new Map([...aggMap].sort());
			}
			// <Strand, CurriculumName>
			let strandNameMap: StrandAggMap = aggMap.get(
				curr.learningArea,
			) as StrandAggMap;
			if (!strandNameMap.has(curr.strand)) {
				strandNameMap.set(curr.strand, new Map<string, Array<Curriculum>>());
				strandNameMap = new Map([...strandNameMap].sort());
			}

			// <CurriculumName, Curriculum>
			let nameCurrMap: NameAggMap = strandNameMap.get(
				curr.strand,
			) as NameAggMap;
			if (!nameCurrMap.has(curr.name)) {
				nameCurrMap = new Map(nameCurrMap).set(curr.name, [curr]);
				nameCurrMap = new Map([...nameCurrMap].sort());
			}

			let currList: Array<Curriculum> = nameCurrMap.get(
				curr.name,
			) as Array<Curriculum>;
			if (currList.findIndex((c) => c.id === curr.id) === -1) {
				currList = Array.from([...currList, curr]).sort(function (a, b) {
					return a.code.localeCompare(b.code);
				});
			}
			// currList = [...currList, curr]
			nameCurrMap.set(curr.name, currList);
			strandNameMap.set(curr.strand, nameCurrMap);
			aggMap.set(curr.learningArea, strandNameMap);
		});
	}
	return aggMap;
}
